/** Akrabalik turleri */
export enum AkrabalikTuru {
  ANNE = 'ANNE',
  BABA = 'BABA',
  ES = 'ES',
  COCUK = 'COCUK',
  KARDES = 'KARDES',
  AMCA = 'AMCA',
  DAYI = 'DAYI',
  HALA = 'HALA',
  TEYZE = 'TEYZE',
  KUZEN = 'KUZEN',
  DEDE_BABA = 'DEDE_BABA',
  DEDE_ANNE = 'DEDE_ANNE',
  NINE_BABA = 'NINE_BABA',
  NINE_ANNE = 'NINE_ANNE',
  TORUN = 'TORUN',
  GELIN = 'GELIN',
  DAMAT = 'DAMAT',
  KAYINVALIDE = 'KAYINVALIDE',
  KAYINPEDER = 'KAYINPEDER',
  YEGEN = 'YEGEN',
  ENISTE = 'ENISTE',
  BALDIZ = 'BALDIZ',
  KAYINBIRADER = 'KAYINBIRADER',
  GORUMCE = 'GORUMCE',
  BUYUK_BABA = 'BUYUK_BABA',
  BUYUK_ANNE = 'BUYUK_ANNE',
  YENGE = 'YENGE',
  ELTI = 'ELTI',
  BACANAK = 'BACANAK',
  KUZENISTE = 'KUZENISTE',
  KUZENGE = 'KUZENGE',
  KUZENCO = 'KUZENCO',
  YEGENCO = 'YEGENCO',
  TORUCO = 'TORUCO',
  TORUGEL = 'TORUGEL',
  TORUDAM = 'TORUDAM',
  KAYINENISTE = 'KAYINENISTE',
  DUNUR = 'DUNUR',
  DIGER = 'DIGER',
}

export interface IAkrabalikBilgi {
  isim: string;
  simge: string;
  renk: string;
  cinsiyet?: 'E' | 'K' | null;
  tersi?: AkrabalikTuru;
  /** Turkce dilbilgisi: "Babanız", "Anneniz" (2. tekil sahiplik) */
  sahipSiz?: string;
  /** Turkce dilbilgisi: "Babası", "Annesi" (3. tekil sahiplik) */
  sahipO?: string;
  /** Turkce dilbilgisi: "Babasının", "Annesinin" (3. tekil tamlayan) */
  tamlayanO?: string;
}

export const AkrabalikBilgi: Record<AkrabalikTuru, IAkrabalikBilgi> = {
  [AkrabalikTuru.ANNE]:          { isim: 'Anne',                simge: '\uD83D\uDC69', renk: '#ec4899', cinsiyet: 'K', tersi: AkrabalikTuru.COCUK,      sahipSiz: 'Anneniz',            sahipO: 'Annesi',             tamlayanO: 'Annesinin' },
  [AkrabalikTuru.BABA]:          { isim: 'Baba',                simge: '\uD83D\uDC68', renk: '#3b82f6', cinsiyet: 'E', tersi: AkrabalikTuru.COCUK,      sahipSiz: 'Babanız',            sahipO: 'Babası',             tamlayanO: 'Babasının' },
  [AkrabalikTuru.ES]:            { isim: 'Eş',                  simge: '\uD83D\uDC91', renk: '#ef4444', cinsiyet: null, tersi: AkrabalikTuru.ES,        sahipSiz: 'Eşiniz',             sahipO: 'Eşi',                tamlayanO: 'Eşinin' },
  [AkrabalikTuru.COCUK]:         { isim: 'Çocuk',               simge: '\uD83D\uDC76', renk: '#10b981', cinsiyet: null, tersi: AkrabalikTuru.BABA,      sahipSiz: 'Çocuğunuz',          sahipO: 'Çocuğu',             tamlayanO: 'Çocuğunun' },
  [AkrabalikTuru.KARDES]:        { isim: 'Kardeş',              simge: '\uD83D\uDC6B', renk: '#8b5cf6', cinsiyet: null, tersi: AkrabalikTuru.KARDES,    sahipSiz: 'Kardeşiniz',         sahipO: 'Kardeşi',            tamlayanO: 'Kardeşinin' },
  [AkrabalikTuru.AMCA]:          { isim: 'Amca',                simge: '\uD83D\uDC68\u200D\uD83E\uDDB1', renk: '#6366f1', cinsiyet: 'E', tersi: AkrabalikTuru.YEGEN,    sahipSiz: 'Amcanız',            sahipO: 'Amcası',             tamlayanO: 'Amcasının' },
  [AkrabalikTuru.DAYI]:          { isim: 'Dayı',                simge: '\uD83D\uDC68\u200D\uD83E\uDDB0', renk: '#0891b2', cinsiyet: 'E', tersi: AkrabalikTuru.YEGEN,    sahipSiz: 'Dayınız',            sahipO: 'Dayısı',             tamlayanO: 'Dayısının' },
  [AkrabalikTuru.HALA]:          { isim: 'Hala',                simge: '\uD83D\uDC69\u200D\uD83E\uDDB1', renk: '#d946ef', cinsiyet: 'K', tersi: AkrabalikTuru.YEGEN,    sahipSiz: 'Halanız',            sahipO: 'Halası',             tamlayanO: 'Halasının' },
  [AkrabalikTuru.TEYZE]:         { isim: 'Teyze',               simge: '\uD83D\uDC69\u200D\uD83E\uDDB0', renk: '#f43f5e', cinsiyet: 'K', tersi: AkrabalikTuru.YEGEN,    sahipSiz: 'Teyzeniz',           sahipO: 'Teyzesi',            tamlayanO: 'Teyzesinin' },
  [AkrabalikTuru.KUZEN]:         { isim: 'Kuzen',               simge: '\uD83E\uDD1D', renk: '#f59e0b', cinsiyet: null, tersi: AkrabalikTuru.KUZEN,    sahipSiz: 'Kuzeniniz',          sahipO: 'Kuzeni',             tamlayanO: 'Kuzeninin' },
  [AkrabalikTuru.DEDE_BABA]:     { isim: 'Dede',              simge: '\uD83D\uDC74', renk: '#1e40af', cinsiyet: 'E', tersi: AkrabalikTuru.TORUN,     sahipSiz: 'Dedeniz',            sahipO: 'Dedesi',             tamlayanO: 'Dedesinin' },
  [AkrabalikTuru.DEDE_ANNE]:     { isim: 'Dede',              simge: '\uD83D\uDC74', renk: '#047857', cinsiyet: 'E', tersi: AkrabalikTuru.TORUN,     sahipSiz: 'Dedeniz',            sahipO: 'Dedesi',             tamlayanO: 'Dedesinin' },
  [AkrabalikTuru.NINE_BABA]:     { isim: 'Babaanne',            simge: '\uD83D\uDC75', renk: '#7c3aed', cinsiyet: 'K', tersi: AkrabalikTuru.TORUN,     sahipSiz: 'Babaanneniz',        sahipO: 'Babaannesi',         tamlayanO: 'Babaannesinin' },
  [AkrabalikTuru.NINE_ANNE]:     { isim: 'Anneanne',            simge: '\uD83D\uDC75', renk: '#be185d', cinsiyet: 'K', tersi: AkrabalikTuru.TORUN,     sahipSiz: 'Anneanneniz',        sahipO: 'Anneannesi',         tamlayanO: 'Anneannesinin' },
  [AkrabalikTuru.TORUN]:         { isim: 'Torun',               simge: '\uD83D\uDC67', renk: '#059669', cinsiyet: null, tersi: AkrabalikTuru.DEDE_BABA, sahipSiz: 'Torununuz',        sahipO: 'Torunu',             tamlayanO: 'Torununun' },
  [AkrabalikTuru.GELIN]:         { isim: 'Gelin',               simge: '\uD83D\uDC70', renk: '#db2777', cinsiyet: 'K', tersi: AkrabalikTuru.KAYINVALIDE, sahipSiz: 'Gelininiz',       sahipO: 'Gelini',             tamlayanO: 'Gelininin' },
  [AkrabalikTuru.DAMAT]:         { isim: 'Damat',               simge: '\uD83E\uDD35', renk: '#1d4ed8', cinsiyet: 'E', tersi: AkrabalikTuru.KAYINPEDER, sahipSiz: 'Damadınız',        sahipO: 'Damadı',             tamlayanO: 'Damadının' },
  [AkrabalikTuru.KAYINVALIDE]:   { isim: 'Kayınvalide',         simge: '\uD83D\uDC69\u200D\uD83E\uDDB3', renk: '#9333ea', cinsiyet: 'K', tersi: AkrabalikTuru.GELIN, sahipSiz: 'Kayınvalideniz', sahipO: 'Kayınvalidesi', tamlayanO: 'Kayınvalidesinin' },
  [AkrabalikTuru.KAYINPEDER]:    { isim: 'Kayınpeder',          simge: '\uD83D\uDC68\u200D\uD83E\uDDB3', renk: '#4f46e5', cinsiyet: 'E', tersi: AkrabalikTuru.DAMAT, sahipSiz: 'Kayınpederiniz', sahipO: 'Kayınpederi', tamlayanO: 'Kayınpederinin' },
  [AkrabalikTuru.YEGEN]:         { isim: 'Yeğen',               simge: '\uD83E\uDDD2', renk: '#0d9488', cinsiyet: null, tersi: AkrabalikTuru.AMCA,     sahipSiz: 'Yeğeniniz',          sahipO: 'Yeğeni',             tamlayanO: 'Yeğeninin' },
  [AkrabalikTuru.ENISTE]:        { isim: 'Enişte',              simge: '\uD83D\uDC68\u200D\uD83D\uDCBC', renk: '#7c2d12', cinsiyet: 'E', tersi: AkrabalikTuru.BALDIZ, sahipSiz: 'Enişteniz', sahipO: 'Eniştesi', tamlayanO: 'Eniştesinin' },
  [AkrabalikTuru.BALDIZ]:        { isim: 'Baldız',              simge: '\uD83D\uDC69\u200D\uD83D\uDCBC', renk: '#be123c', cinsiyet: 'K', tersi: AkrabalikTuru.ENISTE, sahipSiz: 'Baldızınız', sahipO: 'Baldızı', tamlayanO: 'Baldızının' },
  [AkrabalikTuru.KAYINBIRADER]:  { isim: 'Kayınbirader',        simge: '\uD83D\uDC68\u200D\uD83D\uDCBC', renk: '#1e3a5f', cinsiyet: 'E', tersi: AkrabalikTuru.ENISTE, sahipSiz: 'Kayınbiraderiniz', sahipO: 'Kayınbiraderi', tamlayanO: 'Kayınbiraderinin' },
  [AkrabalikTuru.GORUMCE]:       { isim: 'Görümce',             simge: '\uD83D\uDC69\u200D\uD83D\uDCBC', renk: '#831843', cinsiyet: 'K', tersi: AkrabalikTuru.YENGE, sahipSiz: 'Görümceniz', sahipO: 'Görümcesi', tamlayanO: 'Görümcesinin' },
  [AkrabalikTuru.BUYUK_BABA]:    { isim: 'Büyük Dede',          simge: '\uD83E\uDDD3', renk: '#1e293b', cinsiyet: 'E', tersi: AkrabalikTuru.TORUCO,    sahipSiz: 'Büyük Dedeniz',      sahipO: 'Büyük Dedesi',       tamlayanO: 'Büyük Dedesinin' },
  [AkrabalikTuru.BUYUK_ANNE]:    { isim: 'Büyük Nine',          simge: '\uD83E\uDDD3', renk: '#4a1942', cinsiyet: 'K', tersi: AkrabalikTuru.TORUCO,    sahipSiz: 'Büyük Nineniz',      sahipO: 'Büyük Ninesi',       tamlayanO: 'Büyük Ninesinin' },
  [AkrabalikTuru.YENGE]:         { isim: 'Yenge',               simge: '\uD83D\uDC69\u200D\uD83E\uDDB1', renk: '#c026d3', cinsiyet: 'K', tersi: AkrabalikTuru.GORUMCE, sahipSiz: 'Yengeniz', sahipO: 'Yengesi', tamlayanO: 'Yengesinin' },
  [AkrabalikTuru.ELTI]:          { isim: 'Elti',                simge: '\uD83D\uDC69\u200D\uD83E\uDDB0', renk: '#e11d48', cinsiyet: 'K', tersi: AkrabalikTuru.ELTI,    sahipSiz: 'Eltiniz',            sahipO: 'Eltisi',             tamlayanO: 'Eltisinin' },
  [AkrabalikTuru.BACANAK]:       { isim: 'Bacanak',             simge: '\uD83D\uDC68\u200D\uD83E\uDDB1', renk: '#0369a1', cinsiyet: 'E', tersi: AkrabalikTuru.BACANAK, sahipSiz: 'Bacanağınız',        sahipO: 'Bacanağı',           tamlayanO: 'Bacanağının' },
  [AkrabalikTuru.KUZENISTE]:     { isim: 'Kuzenişte',            simge: '\uD83D\uDC68\u200D\uD83E\uDD1D', renk: '#b45309', cinsiyet: 'E', tersi: AkrabalikTuru.KUZENISTE, sahipSiz: 'Kuzenişteniz',    sahipO: 'Kuzeniştesi',         tamlayanO: 'Kuzeniştesinin' },
  [AkrabalikTuru.KUZENGE]:       { isim: 'Kuzenge',              simge: '\uD83D\uDC69\u200D\uD83E\uDD1D', renk: '#c2410c', cinsiyet: 'K', tersi: AkrabalikTuru.KUZENGE, sahipSiz: 'Kuzengeniz',      sahipO: 'Kuzengesi',           tamlayanO: 'Kuzengesinin' },
  [AkrabalikTuru.KUZENCO]:       { isim: 'Kuzenço',              simge: '\uD83D\uDC76\u200D\uD83E\uDD1D', renk: '#d97706', cinsiyet: null, tersi: AkrabalikTuru.KUZEN, sahipSiz: 'Kuzençonuz',       sahipO: 'Kuzençosu',           tamlayanO: 'Kuzençosunun' },
  [AkrabalikTuru.YEGENCO]:       { isim: 'Yeğenço',              simge: '\uD83D\uDC76', renk: '#0891b2', cinsiyet: null, tersi: AkrabalikTuru.AMCA, sahipSiz: 'Yeğençonuz',        sahipO: 'Yeğençosu',           tamlayanO: 'Yeğençosunun' },
  [AkrabalikTuru.TORUCO]:       { isim: 'Toruço',              simge: '\uD83D\uDC76', renk: '#7c3aed', cinsiyet: null, tersi: AkrabalikTuru.BUYUK_BABA, sahipSiz: 'Toruçonuz',    sahipO: 'Toruçosu',           tamlayanO: 'Toruçosunun' },
  [AkrabalikTuru.TORUGEL]:       { isim: 'Torugel',              simge: '\uD83D\uDC70', renk: '#be185d', cinsiyet: 'K', tersi: AkrabalikTuru.KAYINVALIDE, sahipSiz: 'Torugeliniz', sahipO: 'Torugeli',          tamlayanO: 'Torugelinin' },
  [AkrabalikTuru.TORUDAM]:       { isim: 'Torudam',              simge: '\uD83E\uDD35', renk: '#1d4ed8', cinsiyet: 'E', tersi: AkrabalikTuru.KAYINPEDER, sahipSiz: 'Torudamınız', sahipO: 'Torudamı',          tamlayanO: 'Torudamının' },
  [AkrabalikTuru.KAYINENISTE]:   { isim: 'Kayın Enişte',        simge: '\uD83D\uDC68\u200D\uD83D\uDCBC', renk: '#6d28d9', cinsiyet: 'E', tersi: AkrabalikTuru.KAYINBIRADER, sahipSiz: 'Kayın Enişteniz', sahipO: 'Kayın Eniştesi', tamlayanO: 'Kayın Eniştesinin' },
  [AkrabalikTuru.DUNUR]:         { isim: 'Dünür',               simge: '\uD83E\uDD1D', renk: '#854d0e', cinsiyet: null, tersi: AkrabalikTuru.DUNUR,    sahipSiz: 'Dünürünüz',          sahipO: 'Dünürü',             tamlayanO: 'Dünürünün' },
  [AkrabalikTuru.DIGER]:         { isim: 'Diğer',               simge: '\uD83D\uDC64', renk: '#6b7280', cinsiyet: null, tersi: AkrabalikTuru.DIGER,    sahipSiz: 'Akrabanız',          sahipO: 'Akrabası',           tamlayanO: 'Akrabasının' },
};

/**
 * Bir bağ kaydından doğru ilişki türünü çözer.
 * kisiId: bakış açısı sahibi kişi
 * bag: { kisi1, kisi2, akrabalikTuru, tersAkrabalikTuru } içeren kayıt (veya bag.veri)
 * Döndürür: kisiId perspektifinden doğru AkrabalikTuru
 */
export function bagdanTurCozumle(kisiId: string, bag: any, karsiCinsiyet?: string): AkrabalikTuru {
  const v = bag?.veri || bag;
  if (!v) return AkrabalikTuru.DIGER;

  const k1 = String(v.kisi1 || '');
  const k2 = String(v.kisi2 || '');
  const kid = String(kisiId || '');

  // kisi1 → kisi2 yönünde kayıt: doğrudan akrabalikTuru
  if (k1 === kid) {
    return v.akrabalikTuru || AkrabalikTuru.DIGER;
  }

  // kisi2 → kisi1 yönünde: ters ilişki gerekiyor
  if (k2 === kid) {
    // 1) Cinsiyet bazlı ters çevir (en güvenilir - COCUK→ANNE/BABA, TORUN→NINE/DEDE vb.)
    if (karsiCinsiyet) {
      const cinsiyetTers = cinsiyetleTurDuzelt(v.akrabalikTuru, karsiCinsiyet);
      if (cinsiyetTers) return cinsiyetTers;
    }

    // 2) DB'de saklanan tersAkrabalikTuru
    if (v.tersAkrabalikTuru) return v.tersAkrabalikTuru;

    // 3) Lookup tablosundan tersi
    const bilgi = AkrabalikBilgi[v.akrabalikTuru as AkrabalikTuru];
    if (bilgi?.tersi) return bilgi.tersi;
  }

  // Fallback
  return v.akrabalikTuru || AkrabalikTuru.DIGER;
}

/** Cinsiyet bazlı ters akrabalık türü belirle (karşı kişinin cinsiyetine göre) */
export function cinsiyetleTurDuzelt(tur: AkrabalikTuru, cinsiyet?: string): AkrabalikTuru | null {
  const kadin = cinsiyet === 'F' || cinsiyet === 'K';
  switch (tur) {
    case AkrabalikTuru.COCUK:  return kadin ? AkrabalikTuru.ANNE : AkrabalikTuru.BABA;
    case AkrabalikTuru.TORUN:  return kadin ? AkrabalikTuru.NINE_BABA : AkrabalikTuru.DEDE_BABA;
    case AkrabalikTuru.YEGEN:  return kadin ? AkrabalikTuru.TEYZE : AkrabalikTuru.AMCA;
    case AkrabalikTuru.GELIN:  return AkrabalikTuru.COCUK;
    case AkrabalikTuru.DAMAT:  return AkrabalikTuru.COCUK;
    case AkrabalikTuru.KUZENCO: return AkrabalikTuru.KUZEN;
    default: return null;
  }
}

/** Onay durumu */
export enum AkrabalikOnayDurumu {
  BEKLEMEDE = 'BEKLEMEDE',
  ONAYLANDI = 'ONAYLANDI',
  REDDEDILDI = 'REDDEDILDI',
}

/** Gizlilik seviyesi - her kisi kendi bilgilerinin gorunurlugunu ayarlayabilir */
export enum GizlilikSeviyesi {
  HERKESE_ACIK = 'HERKESE_ACIK',
  SADECE_AILE = 'SADECE_AILE',
  SADECE_BEN = 'SADECE_BEN',
}

/** Medeni durum */
export enum MedeniDurum {
  BEKAR = 'BEKAR',
  EVLI = 'EVLI',
  BOSANMIS = 'BOSANMIS',
  DUL = 'DUL',
  NISANLI = 'NISANLI',
}

/** Yasam olayi turu */
export enum YasamOlayiTuru {
  DOGUM = 'DOGUM',
  EVLILIK = 'EVLILIK',
  COCUK_DOGUMU = 'COCUK_DOGUMU',
  MESLEK = 'MESLEK',
  EGITIM = 'EGITIM',
  TASIMA = 'TASIMA',
  VEFAT = 'VEFAT',
  ANI = 'ANI',
  DIGER = 'DIGER',
}

/** Yasam olayi */
export interface IYasamOlayi {
  _id: string;
  turu: YasamOlayiTuru;
  tarih: string;
  baslik: string;
  aciklama?: string;
  konum?: string;
  /** Ses kaydı (base64 audio/webm veya audio/ogg) */
  sesKaydiUrl?: string;
  /** Oluşturma zamanı (sıralama için) */
  olusturmaTarihi?: string;
}

/** Adres turu */
export enum AdresTuru {
  DOGUM = 'DOGUM',
  VEFAT = 'VEFAT',
  DEFIN = 'DEFIN',
  EV = 'EV',
  IS = 'IS',
  OKUL = 'OKUL',
  DIGER = 'DIGER',
}

/** Adres kaydi */
export interface IAdres {
  _id?: string;
  tur: AdresTuru;
  adres: string;
  baslangicTarihi?: string;
  bitisTarihi?: string;
  not?: string;
  notlar?: string;
  koordinat?: { lat: number; lng: number };
}

/** Fotograf */
export interface IFotograf {
  _id: string;
  url: string;
  aciklama?: string;
  tarih?: string;
}

/** Kisi profili - IElleGirilenKisi'nin genisletilmis hali */
export interface IKisiProfil {
  isim: string;
  soyIsim: string;
  kizlikSoyadi?: string;
  cinsiyet: 'E' | 'K';
  dogumTarihi?: string;
  dogumYeri?: string;
  olumTarihi?: string;
  olumYeri?: string;
  vefatEtti: boolean;
  meslek?: string;
  medeniDurum?: MedeniDurum;
  biyografi?: string;
  resimUrl?: string;
  fotograflar?: IFotograf[];
  yasamOlaylari?: IYasamOlayi[];
  notlar?: string;
  gizlilik?: IGizlilikAyarlari;
}

/** Gizlilik ayarlari - her alan icin ayri gorunurluk */
export interface IGizlilikAyarlari {
  dogumTarihi?: GizlilikSeviyesi;
  dogumYeri?: GizlilikSeviyesi;
  meslek?: GizlilikSeviyesi;
  biyografi?: GizlilikSeviyesi;
  fotograflar?: GizlilikSeviyesi;
  yasamOlaylari?: GizlilikSeviyesi;
  varsayilan: GizlilikSeviyesi;
}

/** Elle girilen kisi (vefat etmis / platformda olmayan) - IKisiProfil alias */
export interface IElleGirilenKisi extends IKisiProfil {}

/** Soy Agaci Kisi Veri Modeli - bagimsiz kisi kaydi (hareketler koleksiyonunda) */
export interface ISoyAgaciKisiVeri {
  isim: string;
  soyIsim: string;
  kizlikSoyadi?: string;
  cinsiyet: 'E' | 'K';
  meslek?: string;
  dogumTarihi?: string;
  dogumYeri?: string;
  olumTarihi?: string;
  olumYeri?: string;
  vefatEtti: boolean;
  medeniDurum?: MedeniDurum;
  biyografi?: string;
  notlar?: string;
  /** Profil resmi (base64 data URL) */
  resimUrl?: string;
  gizlilik?: IGizlilikAyarlari;
  /** Platform uyesi ise goUyeler._id referansi */
  platformKullaniciId?: string;
  /** Fotoğraf albümü */
  fotograflar?: IFotograf[];
  /** Yaşam olayları ve anılar */
  yasamOlaylari?: IYasamOlayi[];
  /** Defin / Mezarlık yeri */
  definYeri?: string;
  /** Zamansal adresler (ev, iş, okul vb.) */
  adresler?: IAdres[];
  /** Doğum koordinatı */
  dogumKoordinat?: { lat: number; lng: number };
  /** Ölüm koordinatı */
  olumKoordinat?: { lat: number; lng: number };
  /** Defin koordinatı */
  definKoordinat?: { lat: number; lng: number };
}

/** Soy Agaci Kisi Kaydi - DB'deki tam kayit */
export interface ISoyAgaciKisiKaydi {
  _id: string;
  vt: string; // "FikoYT.sistem.soyAgaciKisiler"
  sahip: string;
  tarih: Date;
  silindi: boolean;
  veri: ISoyAgaciKisiVeri;
}

/** Aile bagi veri modeli */
export interface IAileBagi {
  kisi1: string;
  kisi2: string;
  akrabalikTuru: AkrabalikTuru;
  tersAkrabalikTuru?: AkrabalikTuru;
  onayDurumu: AkrabalikOnayDurumu;
  /** @deprecated Yeni yapida kullanilmiyor, migrasyon icin geriye uyumlu */
  platformUyesiMi?: boolean;
  /** @deprecated Yeni yapida kisi kaydi ayri tutuluyor, migrasyon icin geriye uyumlu */
  elleGirilenKisi?: IElleGirilenKisi;
  onayTarihi?: Date;
  notlar?: string;
}

/** Family-chart dugum formati */
export interface IFamilyChartDugum {
  id: string;
  data: {
    gender: 'M' | 'F';
    'first name': string;
    'last name': string;
    birthday?: string;
    avatar?: string;
    fikoytId?: string;
    platformUyesi?: boolean;
    vefatEtti?: boolean;
    olumTarihi?: string;
    meslek?: string;
    dogumYeri?: string;
    olumYeri?: string;
    kizlikSoyadi?: string;
    medeniDurum?: MedeniDurum;
    biyografi?: string;
    /** Aktif kullaniciya gore akrabalik turu */
    akrabalikTuru?: string;
    akrabalikSimge?: string;
    akrabalikRenk?: string;
  };
  rels: {
    spouses?: string[];
    children?: string[];
    parents?: string[];
  };
}

/** Agac gorunum modlari */
export type AgacGorunumModu = 'tam' | 'ata' | 'torun' | 'kumbaraci';

/** Aile istatistikleri */
export interface IAileIstatistikleri {
  toplamUye: number;
  nesilSayisi: number;
  cinsiyetDagilimi: { erkek: number; kadin: number };
  yasayanSayisi: number;
  vefatSayisi: number;
  ortalamaYasam?: number;
  ortalamaVefatYasi?: number;
  enYasliKisi?: { isim: string; yas: number };
  enGencKisi?: { isim: string; yas: number };
  enCokIsim: { isim: string; sayi: number }[];
  sehirDagilimi: { sehir: string; sayi: number }[];
  meslekDagilimi: { meslek: string; sayi: number }[];
}

/** Zaman cizelgesi olayi */
export interface IZamanCizelgesiOlayi {
  tarih: string;
  baslik: string;
  aciklama?: string;
  turu: YasamOlayiTuru;
  kisiId?: string;
  kisiIsim?: string;
  konum?: string;
  renk?: string;
}

/** Akrabalik yolu adimi */
export interface IAkrabalikAdim {
  kisiId: string;
  kisi?: any;
  akrabalikTuru: AkrabalikTuru;
}

/** Akrabalik yolu sonucu */
export interface IAkrabalikYolu {
  kisi1: any;
  kisi2: any;
  yol: IAkrabalikAdim[];
  mesafe: number;
  aciklama: string;
}

/** Adres türü bilgileri (emoji, renk vb.) */
export const AdresTuruBilgi: Record<AdresTuru, { isim: string; simge: string; renk: string }> = {
  [AdresTuru.DOGUM]: { isim: 'Doğum Yeri', simge: '🌟', renk: '#4ade80' },
  [AdresTuru.VEFAT]: { isim: 'Vefat Yeri', simge: '🕊️', renk: '#f87171' },
  [AdresTuru.DEFIN]: { isim: 'Defin Yeri', simge: '⚰️', renk: '#6b7280' },
  [AdresTuru.EV]: { isim: 'Ev', simge: '🏠', renk: '#10b981' },
  [AdresTuru.IS]: { isim: 'İş', simge: '🏢', renk: '#3b82f6' },
  [AdresTuru.OKUL]: { isim: 'Okul', simge: '🎓', renk: '#8b5cf6' },
  [AdresTuru.DIGER]: { isim: 'Diğer', simge: '📍', renk: '#f59e0b' },
};
